export const AcaoArquivo = {DOWNLOAD : 0, COMPARTILHAR: 1, ABRIR: 2 }